import { UIText1 } from '@cian/ui-kit';
import { IconActionChevronDownSmall16 } from '@cian/ui-kit-design-tokens/icons';
import cx from 'clsx';
import * as React from 'react';
import { pluralize } from 'shared/utils/pluralize';

import * as styles from './MortgageOffersExpandToggle.css';

export interface IMortgageOffersExpandToggleProps {
  expanded: boolean;
  count: number;
  onClick: () => void;
}

export const MortgageOffersExpandToggle: React.FC<React.PropsWithChildren<IMortgageOffersExpandToggleProps>> = ({
  count,
  expanded,
  onClick,
}) => {
  const offersText = pluralize(count, ['предложение', 'предложения', 'предложений']);
  const buttonText = expanded ? `Скрыть ${offersText}` : `Показать ещё ${offersText}`;

  return (
    <div className={styles['container']} onClick={onClick} role="button" data-testid="MortgageOffersExpandToggle">
      <UIText1 color="text-main-default">{buttonText}</UIText1>
      <span className={cx(styles['arrow'], expanded && styles['arrow__expanded'])}>
        <IconActionChevronDownSmall16 color="icon-main-default" />
      </span>
    </div>
  );
};
